import styled from 'styled-components';
import { Grid } from '@material-ui/core';

export const ContainerDiv = styled.div`
    text-align: center;
`;

export const DateBarDiv = styled.div`
    padding: 10px 5px;
    margin: 10px 0px;
    background-color: #e8e8e8;
    display: flex;
    align-items: center;
`;

export const CustomGrid = styled(Grid)`
    display: flex;
    justify-content: center;
    align-items: center;
`;
